import { desktopContentMaxWidth, desktopContentMinWidthExclusive } from 'layouts/styles';

export default {
  wrapperNew: {
    maxWidth: desktopContentMaxWidth,
    margin: '0 auto',
    flex: 1,
  },
  wrapperNewFullWidth: {
    flex: 1,
  },
  phoneMinWidth: {
    minWidth: desktopContentMinWidthExclusive,
    '@media screen and (max-width: 600px)': {
      minWidth: 0,
    },
  },
};
